/* globals jQuery:true, ajaxurl:true, wf_sn:true, sn_block_ui:true */
/*
 * Security Ninja - Scheduled Scanner add-on
 * (c) Web factory 2015
 * Updated 2020 - Larsik Corp
 */

 jQuery(document).ready(function($){
  // run tests, via ajax
  $('#sn-ss-test').on('click', function(){
    if (!confirm('Please remember to save settings before testing them. Continue?')) {
      return;
    }
    var data = {
      action: 'sn_ss_cs_test',
      '_ajax_nonce': wf_sn.nonce_run_tests
    };

    sn_block_ui('#sn-scheduled-scanner');

    $.post(ajaxurl, data, function(response) {
      window.console.log(response);
      if (response != '1') {
        alert('Undocumented error. Page will automatically reload.');
        window.location.reload();
      } else {
        window.location.reload();
      }
    });
  }); // run tests

  // truncate log table
  $('#wf-sn-ss-truncate-log').on('click', function(){
    var answer = confirm("Are you sure you want to delete all log entries?");
    if (answer) {
      var data = {action: 'sn_ss_truncate_log'};
      $.post(ajaxurl, data, function(response) {
        if (!response) {
          alert('Bad AJAX response. Please reload the page.');
        } else {
          window.location.reload();
        }
      });
    }
    return false;
  });

  // security ninja results details
  $('.ss-details-sn').on('click', function(){
    var data = {action: 'sn_ss_sn_details', row_id: $(this).attr('data-row-id') };
    var timestamp = $(this).attr('data-timestamp');

    $.post(ajaxurl, data, function(response) {
      if (!response) {
        alert('Bad AJAX response. Please reload the page.');
      } else {
        $('#wf-ss-dialog').html(response)
        .dialog({ title: 'Security Ninja results from ' + timestamp })
        .dialog('open');
      }
    });
    return false;
  });




  // cores canner results details
  $('.ss-details-cs').on('click', function(){
    var data = {
      action: 'sn_ss_cs_details',
      row_id: $(this).attr('data-row-id')
    };
    var timestamp = $(this).attr('data-timestamp');

    $.post(ajaxurl, data, function(response) {
      if (!response) {
        alert('Bad AJAX response. Please reload the page.');
      } else {
        $('#wf-ss-dialog').html(response)
        .dialog({ 
          title: 'Core Scanner results from ' + timestamp 
        })
        .dialog('open');
      }
    });
    return false;
  });





  // prepare dialog
  $('#wf-ss-dialog').dialog({
    'dialogClass': 'wp-dialog',
    'modal': true,
    'resizable': true,
    'zIndex': 9999,
    'width': 900,
    'height': '550',
    'hide': 'fade',
    'show': 'fade',
    'autoOpen': false,
    'closeOnEscape': true
  });

});